export default __webpack_public_path__ + "static/media/trash.c6bdc883.svg";